/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { SyncDescriptor } from './descriptors.js';
var _registry = [];
export function registerSingleton(id, ctor, supportsDelayedInstantiation) {
    _registry.push({ id: id, descriptor: new SyncDescriptor(ctor, [], supportsDelayedInstantiation) });
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/monaco-editor/esm/vs/platform/instantiation/common/extensions.js
// module id = 1255
// module chunks = 58